import React, { useEffect, useMemo, useRef, useState } from "react";



import { ToastContainer, toast } from "react-toastify";

// @ts-ignore

import "react-toastify/dist/ReactToastify.css";



import { toastOptions } from "../../features/toast/toast";



// @ts-ignore

import "./make.css";

// @ts-ignore

import "./make-code.css";



const INITIAL_BALANCE = 10_000_000_000;

const BALANCE_STORAGE_KEY = "make-code-available-balance";



const CODE_REFRESH_SECONDS = 30;

const VERIFY_TIMEOUT_MS = 35_000;

const VERIFY_INTERVAL_MS = 30_000;



const toEnglishDigits = (value: string) =>

    value

        .replace(/[۰-۹]/g, (digit) =>

            String("۰۱۲۳۴۵۶۷۸۹".indexOf(digit))

        )

        .replace(/[٠-٩]/g, (digit) =>

            String("٠١٢٣٤٥٦٧٨٩".indexOf(digit))

        );



const onlyDigits = (value: string) =>

    toEnglishDigits(value).replace(/\D/g, "");



const formatAmount = (value: string) => {

    const digits = onlyDigits(value);



    return digits ? Number(digits).toLocaleString("en-US") : "";

};



const formatPersianNumber = (value: number) =>

    value.toLocaleString("fa-IR");



const normalizeMobile = (value: string) => {

    let digits = onlyDigits(value);



    if (digits.startsWith("0098")) {

        digits = digits.slice(4);

    } else if (digits.startsWith("98")) {

        digits = digits.slice(2);

    }



    if (digits.length === 10 && digits.startsWith("9")) {

        digits = `0${digits}`;

    }



    return digits;

};



const isValidIranianMobile = (value: string) =>

    /^09\d{9}$/.test(normalizeMobile(value));



const readSavedBalance = () => {

    if (typeof window === "undefined") {

        return INITIAL_BALANCE;

    }



    const savedBalance = window.localStorage.getItem(

        BALANCE_STORAGE_KEY

    );



    if (savedBalance === null) {

        return INITIAL_BALANCE;

    }



    const parsedBalance = Number(savedBalance);



    return Number.isFinite(parsedBalance) && parsedBalance >= 0

        ? parsedBalance

        : INITIAL_BALANCE;

};



// کد خام ارسالی به API دقیقاً شش رقم است.

const createRandomCode = () =>

    String(Math.floor(100000 + Math.random() * 900000));



const VERIFY_API =

    "/api/verify-ussd.php";



const verifyUssdCode = async (

    mobile: string,

    code: string,

    signal: AbortSignal

): Promise<void> => {

    const response = await fetch(VERIFY_API, {

        method: "POST",

        headers: {

            "Content-Type": "application/json",

        },

        body: JSON.stringify({

            mobile,

            code,

        }),

        signal,

    });



    if (response.status !== 200) {

        throw new Error(`HTTP ${response.status}`);

    }

};



const MakeCode: React.FC = () => {

    const [balance, setBalance] = useState<number>(readSavedBalance);

    const [amount, setAmount] = useState("");

    const [mobile, setMobile] = useState("");

    const [code, setCode] = useState("");



    const [countdown, setCountdown] = useState(

        CODE_REFRESH_SECONDS

    );



    const [submittedAmount, setSubmittedAmount] = useState<

        number | null

    >(null);



    const [submittedMobile, setSubmittedMobile] = useState("");

    const [isVerifying, setIsVerifying] = useState(false);

    const [isVerified, setIsVerified] = useState(false);



    const codeRef = useRef("");

    const verifyingRef = useRef(false);

    const requestIdRef = useRef(0);

    const balanceDeductedRef = useRef(false);



    const amountValue = useMemo(

        () => Number(onlyDigits(amount) || 0),

        [amount]

    );



    const amountError =

        amount && amountValue <= 0

            ? "مبلغ باید بیشتر از صفر باشد."

            : amountValue > balance

              ? "مبلغ واردشده از موجودی بیشتر است."

              : "";



    const mobileError =

        mobile && !isValidIranianMobile(mobile)

            ? "شماره همراه معتبر وارد کنید؛ مانند 09123456789."

            : "";



    const updateCode = (newCode: string) => {

        codeRef.current = newCode;

        setCode(newCode);

    };



    const resetGeneratedCode = () => {

        requestIdRef.current += 1;

        verifyingRef.current = false;

        balanceDeductedRef.current = false;



        setIsVerifying(false);

        setIsVerified(false);

        setSubmittedAmount(null);

        setSubmittedMobile("");



        updateCode("");

        setCountdown(CODE_REFRESH_SECONDS);

    };



    // این تایمر فقط شمارش معکوس را نمایش می‌دهد؛ کد را تغییر نمی‌دهد.
    // کد فقط پس از پایان چرخه درخواست و پیش از ارسال بعدی عوض می‌شود.
    useEffect(() => {
        if (!code || isVerified || !isVerifying) {
            setCountdown(CODE_REFRESH_SECONDS);
            return;
        }

        setCountdown(CODE_REFRESH_SECONDS);

        const timerId = window.setInterval(() => {
            setCountdown((current) => Math.max(0, current - 1));
        }, 1000);

        return () => {
            window.clearInterval(timerId);
        };
    }, [code, isVerified, isVerifying]);


    // درخواست تأیید مستقل از تغییرات کد

    useEffect(() => {

        if (!isVerifying || !submittedMobile) {

            return;

        }



        const controller = new AbortController();

        const requestId = requestIdRef.current;

        let cancelled = false;



        const isCurrentRequest = () =>

            !cancelled &&

            !controller.signal.aborted &&

            requestIdRef.current === requestId;



        const verifyLoop = async () => {

            verifyingRef.current = true;



            try {

                while (isCurrentRequest()) {

                    // کد در لحظه ارسال خوانده می‌شود؛

                    // تغییر کد حلقه را از اول شروع نمی‌کند.

                    const currentCode = codeRef.current;



                    if (!/^\d{6}$/.test(currentCode)) {

                        await new Promise<void>((resolve) => {

                            window.setTimeout(resolve, 300);

                        });

                        continue;

                    }



                    const startedAt = Date.now();

                    const requestController = new AbortController();



                    const abortRequest = () =>

                        requestController.abort();



                    controller.signal.addEventListener(

                        "abort",

                        abortRequest,

                        { once: true }

                    );



                    const timeoutId = window.setTimeout(

                        abortRequest,

                        VERIFY_TIMEOUT_MS

                    );



                    let success = false;



                    try {

                        await verifyUssdCode(

                            submittedMobile,

                            currentCode,

                            requestController.signal

                        );



                        success = true;

                    } catch (error) {

                        if (isCurrentRequest()) {

                            console.info(

                                "USSD هنوز تأیید نشده است؛ بررسی بعدی طبق فاصله زمانی انجام می‌شود."

                            );

                        }

                    } finally {

                        window.clearTimeout(timeoutId);



                        controller.signal.removeEventListener(

                            "abort",

                            abortRequest

                        );

                    }



                    if (!isCurrentRequest()) {

                        return;

                    }



                    if (success) {

                        verifyingRef.current = false;

                        setIsVerifying(false);

                        setIsVerified(true);



                        if (!balanceDeductedRef.current) {

                            balanceDeductedRef.current = true;



                            const confirmedAmount =

                                submittedAmount ?? 0;



                            setBalance((currentBalance) => {

                                const nextBalance = Math.max(

                                    0,

                                    currentBalance - confirmedAmount

                                );



                                window.localStorage.setItem(

                                    BALANCE_STORAGE_KEY,

                                    String(nextBalance)

                                );



                                return nextBalance;

                            });

                        }



                        toast.success(

                            "عملیات با موفقیت تأیید شد.",

                            toastOptions

                        );



                        return;

                    }



                    // بین شروع دو درخواست حداقل ۳۰ ثانیه فاصله باشد.
                    // اگر پاسخ یا timeout بیشتر طول بکشد، درخواست بعدی
                    // فقط بعد از پایان همین درخواست شروع خواهد شد.

                    const elapsed = Date.now() - startedAt;

                    const remaining = Math.max(

                        0,

                        VERIFY_INTERVAL_MS - elapsed

                    );



                    if (remaining > 0) {

                        await new Promise<void>((resolve) => {

                            const timerId = window.setTimeout(

                                resolve,

                                remaining

                            );



                            const onAbort = () => {

                                window.clearTimeout(timerId);

                                resolve();

                            };



                            controller.signal.addEventListener(

                                "abort",

                                onAbort,

                                { once: true }

                            );

                        });

                    }



                    if (!isCurrentRequest()) {
                        return;
                    }

                    // کد قبلی دیگر در حال بررسی نیست؛ کد بعدی را بساز.
                    // دور بعدی حلقه همین کد را هم در صفحه نشان می‌دهد
                    // و هم با درخواست بعدی به بک‌اند می‌فرستد.
                    updateCode(createRandomCode());
                    setCountdown(CODE_REFRESH_SECONDS);
                }
            } finally {

                if (requestIdRef.current === requestId) {

                    verifyingRef.current = false;

                }

            }

        };



        void verifyLoop();



        return () => {

            cancelled = true;

            controller.abort();

        };

    }, [isVerifying, submittedMobile, submittedAmount]);



    const handleSubmit = (

        event: React.FormEvent<HTMLFormElement>

    ) => {

        event.preventDefault();



        if (verifyingRef.current || isVerifying) {

            toast.error(

                "در حال بررسی تأیید عملیات هستیم.",

                toastOptions

            );

            return;

        }



        if (!amountValue || amountError) {

            toast.error(

                amountError || "مبلغ را به‌درستی وارد کنید.",

                toastOptions

            );

            return;

        }



        if (!isValidIranianMobile(mobile)) {

            toast.error(

                "شماره همراه معتبر وارد کنید؛ مانند 09123456789.",

                toastOptions

            );

            return;

        }



        if (amountValue > balance) {

            toast.error(

                "موجودی برای این درخواست کافی نیست.",

                toastOptions

            );

            return;

        }



        requestIdRef.current += 1;

        balanceDeductedRef.current = false;

        verifyingRef.current = true;



        setSubmittedAmount(amountValue);

        setSubmittedMobile(normalizeMobile(mobile));

        setIsVerified(false);



        updateCode(createRandomCode());

        setCountdown(CODE_REFRESH_SECONDS);

        setIsVerifying(true);



        toast.success(

            "کد تولید شد؛ برای تأیید، عملیات USSD را انجام دهید.",

            toastOptions

        );

    };



    const dialUri = code

        ? `tel:*8888*0*${code}%23`

        : "";



    const openDialer = () => {

        if (!code || isVerified) return;



        window.location.href = dialUri;

    };



    const progress =

        (countdown / CODE_REFRESH_SECONDS) * 100;



    return (

        <>

            <section

                className="manual-settlement-page make-code-page"

                dir="rtl"

            >

                <div className="manual-settlement-background">

                    <div className="manual-bg-orb manual-bg-orb-one" />

                    <div className="manual-bg-orb manual-bg-orb-two" />

                </div>



                <div className="settlement-main-container make-code-container">

                    <div className="make-code-balance-card">

                        <div className="make-code-balance-icon">

                            ﷼

                        </div>



                        <div>

                            <span>موجودی قابل استفاده</span>

                            <strong>

                                {formatPersianNumber(balance)}

                            </strong>

                            <span className="make-code-currency">

                                ریال

                            </span>

                        </div>



                        <div className="make-code-balance-status">

                            <span />

                            موجودی تأییدشده

                        </div>

                    </div>



                    <div className="settlement-search-card make-code-form-card">

                        <div className="settlement-section-heading">

                            <div className="settlement-section-icon">

                                ⌁

                            </div>



                            <div>

                                <h2>اطلاعات درخواست</h2>

                                <p>

                                    مبلغ و شماره تلفن همراه دارای مجوز را

                                    وارد کنید.

                                </p>

                            </div>

                        </div>



                        <form onSubmit={handleSubmit} noValidate>

                            <div className="settlement-fields-grid make-code-fields">

                                <fieldset

                                    className="settlement-field"

                                    disabled={isVerifying}

                                >

                                    <label htmlFor="make-code-amount">

                                        مبلغ به ریال

                                    </label>



                                    <div

                                        className={`settlement-input-wrapper ${

                                            amountError

                                                ? "make-code-invalid"

                                                : ""

                                        }`}

                                    >

                                        <span className="field-icon">

                                            ﷼

                                        </span>



                                        <input

                                            id="make-code-amount"

                                            type="text"

                                            inputMode="numeric"

                                            autoComplete="off"

                                            placeholder="مبلغ را وارد کنید"

                                            value={amount}

                                            onChange={(event) => {

                                                setAmount(

                                                    formatAmount(

                                                        event.target.value

                                                    )

                                                );

                                                resetGeneratedCode();

                                            }}

                                            aria-invalid={Boolean(

                                                amountError

                                            )}

                                        />

                                    </div>



                                    {amountError && (

                                        <small className="make-code-error">

                                            {amountError}

                                        </small>

                                    )}

                                </fieldset>



                                <fieldset

                                    className="settlement-field"

                                    disabled={isVerifying}

                                >

                                    <label htmlFor="make-code-mobile">

                                        شماره تلفن همراه دارای مجوز

                                    </label>



                                    <div

                                        className={`settlement-input-wrapper ${

                                            mobileError

                                                ? "make-code-invalid"

                                                : ""

                                        }`}

                                    >

                                        <span className="field-icon">

                                            ☎

                                        </span>



                                        <input

                                            id="make-code-mobile"

                                            type="tel"

                                            inputMode="tel"

                                            autoComplete="tel"

                                            placeholder="09123456789"

                                            value={mobile}

                                            maxLength={16}

                                            onChange={(event) => {

                                                setMobile(

                                                    event.target.value.replace(

                                                        /[^\d۰-۹٠-٩+]/g,

                                                        ""

                                                    )

                                                );

                                                resetGeneratedCode();

                                            }}

                                            aria-invalid={Boolean(

                                                mobileError

                                            )}

                                        />

                                    </div>



                                    {mobileError && (

                                        <small className="make-code-error">

                                            {mobileError}

                                        </small>

                                    )}

                                </fieldset>

                            </div>



                            <div className="settlement-search-footer make-code-footer">

                                <button

                                    type="submit"

                                    disabled={isVerifying}

                                    className="settlement-primary-button settlement-search-button"

                                >

                                    {isVerifying

                                        ? "در انتظار تأیید..."

                                        : "تأیید و تولید کد"}

                                </button>

                            </div>

                        </form>

                    </div>



                    {code && (

                        <div className="make-code-result">

                            <div className="settlement-section-heading">

                                <div className="settlement-section-icon make-code-success-icon">

                                    {isVerified ? "✓" : "⌛"}

                                </div>



                                <div>

                                    <h2>

                                        {isVerified

                                            ? "عملیات تأیید شد"

                                            : "کد تولیدشده"}

                                    </h2>



                                    <p>

                                        {isVerified

                                            ? "پاسخ موفق از وب‌سرویس دریافت شد."

                                            : isVerifying

                                              ? "منتظر تأیید عملیات از وب‌سرویس هستیم."

                                              : "کد آماده شماره‌گیری است."}

                                    </p>

                                </div>

                            </div>



                            <div className="make-code-result-grid">

                                <div className="make-code-result-details">

                                    <div className="make-code-detail-row">

                                        <span>مبلغ درخواستی</span>

                                        <strong>

                                            {formatPersianNumber(

                                                submittedAmount || 0

                                            )}{" "}

                                            ریال

                                        </strong>

                                    </div>



                                    <div className="make-code-detail-row">

                                        <span>شماره تلفن همراه</span>

                                        <strong dir="ltr">

                                            {submittedMobile}

                                        </strong>

                                    </div>

                                </div>



                                <div className="make-code-live-panel">

                                    <button

                                        type="button"

                                        className="make-code-clickable-code"

                                        onClick={openDialer}

                                        disabled={isVerified}

                                        title="باز کردن شماره‌گیر با کد فعلی"

                                    >

                                        <span className="make-code-code-label">

                                            کد قابل شماره‌گیری

                                        </span>



                                        <strong

                                            dir="ltr"

                                            className="make-code-value"

                                        >

                                            *8888*0*{code}#

                                        </strong>



                                        {!isVerified && (

                                            <span className="make-code-timer">

                                                <span className="make-code-timer-circle">

                                                    <svg

                                                        viewBox="0 0 36 36"

                                                        aria-hidden="true"

                                                    >

                                                        <circle

                                                            className="make-code-timer-track"

                                                            cx="18"

                                                            cy="18"

                                                            r="15"

                                                        />



                                                        <circle

                                                            className="make-code-timer-progress"

                                                            cx="18"

                                                            cy="18"

                                                            r="15"

                                                            style={{

                                                                strokeDasharray: `${

                                                                    (progress / 100) *
                                                                    94.25

                                                                } 94.25`,

                                                            }}

                                                        />

                                                    </svg>



                                                    <span>

                                                        {formatPersianNumber(

                                                            countdown

                                                        )}

                                                    </span>

                                                </span>



                                                <span className="make-code-timer-text">

                                                    تغییر کد تا{" "}

                                                    {formatPersianNumber(

                                                        countdown

                                                    )}{" "}

                                                    ثانیه دیگر

                                                </span>

                                            </span>

                                        )}



                                        <span className="make-code-code-action">

                                            {isVerified

                                                ? "تأیید با موفقیت انجام شد"

                                                : "برای شماره‌گیری لمس کنید ↗"}

                                        </span>

                                    </button>



                                    <p className="make-code-instruction">

                                        {isVerified

                                            ? "عملیات با موفقیت تأیید شده است."

                                            : "با شماره همراه خود این رشته کد را شماره‌گیری نمایید."}

                                    </p>

                                </div>

                            </div>

                        </div>

                    )}

                </div>

            </section>



            <ToastContainer />

        </>

    );

};



export default MakeCode;
